import { get, find } from 'lodash';

class Performance {
  constructor() {
    this.perfMap = {
      inv_no: 'Id',
      description: 'Description',

      type: 'Type.Description',
      text1: 'Text1',
      text2: 'Text2',
      text3: 'Text3',
      text4: 'Text4',
      perf_dt: 'Date',
      composerfn: '',
      composermn: '',
      composerln: '',
      facility_desc: 'Facility.Description',
      on_sale_ind: 'AvailSaleIndicator',
      performance_type: 'Type.Description',
      perf_type_id: 'Type.Id',
      seat_ind: '',
      print_ind: '',
      zmap_no: 'ZoneMap.Id',
      facility_no: 'Facility.Id',
      prod_season_no: 'ProductionSeason.Id',
      season_no: 'ProductionSeason.Season.Id',
      season_desc: 'ProductionSeason.Season.Description',
      start_dt: 'DefaultStartSaleDateTime',
      end_dt: 'DefaultEndSaleDateTime',
      perf_status: 'Status.Id',
      perf_status_desc: 'Status.Description',
      time_slot: 'TimeSlot.Id',
      time_slot_desc: 'TimeSlot.Description',
      ga_ind: ''
    };

    this.priceMap = {
      price_type_desc: 'detail.Description',
      perf_no: 'price.PerformanceId',
      pkg_no: 'price.PackageId',
      zone_no: 'price.ZoneId',
      price_type: 'price.PriceTypeId',
      price: 'price.Price',
      base_price: '',
      description: 'detail.Description',
      available: 'price.Enabled',
      avail_count: 'availability.AvailableCount'
    };

    this.webContentMap = {
      orig_inv_no: 'Owner.ElementId',
      inv_no: 'Owner.ElementId',
      inv_type: '',
      content_type: 'Type.Id',
      content_type_desc: 'Type.Description',
      content_value: 'Value'
    };
  }

  map(responses) {
    let perf = {};
    for (let p in this.perfMap) {
      perf[p] = get(
        responses,
        ['0', 'result'].concat(this.perfMap[p].split('.'))
      );
    }

    let prices = this.mergePriceData(
      responses[1].result,
      responses[2].result,
      responses[3].result
    );

    let price = [];
    if (prices.length) {
      for (let x = 0; x < prices.length; x++) {
        let thePrice = {};
        for (let p in this.priceMap) {
          if (p === 'price') {
            thePrice[p] = get(
              prices[x],
              this.priceMap[p].split('.')
            ).toString();
          } else {
            thePrice[p] = get(prices[x], this.priceMap[p].split('.'));
          }
        }
        price.push(thePrice);
      }
    }

    let webContent = [];
    if (
      responses[4].hasOwnProperty('result') &&
      responses[4].result[0] !== undefined &&
      responses[4].result[0].hasOwnProperty('WebContents')
    ) {
      for (let x = 0; x < responses[4].result[0].WebContents.length; x++) {
        let _ref = responses[4].result[0].WebContents[x];
        let theContent = {};
        for (let p in this.webContentMap) {
          theContent[p] = get(_ref, this.webContentMap[p].split('.'));
        }

        webContent.push(theContent);
      }
    }

    return {
      Package: perf,
      PriceType: price,
      AllPrice: price,
      WebContent: webContent
    };
  }

  mergePriceData(prices, details, availabilities) {
    let allPrices = [];
    for (let x = 0; x < prices.length; x++) {
      let thisPrice = prices[x];
      let detail = find(details, { PriceTypeId: thisPrice.PriceTypeId });
      let availability = find(availabilities, {
        Zone: {
          Id: thisPrice.ZoneId
        }
      });

      allPrices.push({
        price: thisPrice,
        detail: detail,
        availability: availability
      });
    }

    return allPrices;
  }
}

export default Performance;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/JSONAPI/maps/Package.js